'use strict';

exports.__esModule = true;

var _typeChecks = require('./type-checks');

var eventually = function eventually(fn, scope, error, payload) {
  if (!_typeChecks.isFunction(fn)) {
    return undefined;
  }

  /**
   * This is a neat trick to get around the promise try/catch:
   * https://github.com/then/promise/blob/master/src/done.js
   *
   * Note: Referencing setTimeout from global allows for higher
   * v8 optimization.
   *
   * Note: `fn.call` is intentionally used over `fn.bind`.
   * This is to respect functions where `bind` has already been
   * invoked (like `ReactComponent::setState`).
   */
  return global.setTimeout(function () {
    return fn.call(scope, error, payload);
  });
};

exports['default'] = eventually;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9ldmVudHVhbGx5LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7MEJBQTJCLGVBQWU7O0FBRTFDLElBQUksVUFBVSxHQUFHLFNBQWIsVUFBVSxDQUFhLEVBQUUsRUFBRSxLQUFLLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRTtBQUNwRCxNQUFJLENBQUMsdUJBQVcsRUFBRSxDQUFDLEVBQUU7QUFDbkIsV0FBTyxTQUFTLENBQUE7R0FDakI7Ozs7Ozs7Ozs7Ozs7QUFhRCxTQUFPLE1BQU0sQ0FBQyxVQUFVLENBQUM7V0FBTSxFQUFFLENBQUMsSUFBSSxDQUFDLEtBQUssRUFBRSxLQUFLLEVBQUUsT0FBTyxDQUFDO0dBQUEsQ0FBQyxDQUFBO0NBQy9ELENBQUE7O3FCQUVjLFVBQVUiLCJmaWxlIjoic3JjL2V2ZW50dWFsbHkuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBpc0Z1bmN0aW9uIH0gZnJvbSAnLi90eXBlLWNoZWNrcydcblxubGV0IGV2ZW50dWFsbHkgPSBmdW5jdGlvbiAoZm4sIHNjb3BlLCBlcnJvciwgcGF5bG9hZCkge1xuICBpZiAoIWlzRnVuY3Rpb24oZm4pKSB7XG4gICAgcmV0dXJuIHVuZGVmaW5lZFxuICB9XG5cbiAgLyoqXG4gICAqIFRoaXMgaXMgYSBuZWF0IHRyaWNrIHRvIGdldCBhcm91bmQgdGhlIHByb21pc2UgdHJ5L2NhdGNoOlxuICAgKiBodHRwczovL2dpdGh1Yi5jb20vdGhlbi9wcm9taXNlL2Jsb2IvbWFzdGVyL3NyYy9kb25lLmpzXG4gICAqXG4gICAqIE5vdGU6IFJlZmVyZW5jaW5nIHNldFRpbWVvdXQgZnJvbSBnbG9iYWwgYWxsb3dzIGZvciBoaWdoZXJcbiAgICogdjggb3B0aW1pemF0aW9uLlxuICAgKlxuICAgKiBOb3RlOiBgZm4uY2FsbGAgaXMgaW50ZW50aW9uYWxseSB1c2VkIG92ZXIgYGZuLmJpbmRgLlxuICAgKiBUaGlzIGlzIHRvIHJlc3BlY3QgZnVuY3Rpb25zIHdoZXJlIGBiaW5kYCBoYXMgYWxyZWFkeSBiZWVuXG4gICAqIGludm9rZWQgKGxpa2UgYFJlYWN0Q29tcG9uZW50OjpzZXRTdGF0ZWApLlxuICAgKi9cbiAgcmV0dXJuIGdsb2JhbC5zZXRUaW1lb3V0KCgpID0+IGZuLmNhbGwoc2NvcGUsIGVycm9yLCBwYXlsb2FkKSlcbn1cblxuZXhwb3J0IGRlZmF1bHQgZXZlbnR1YWxseVxuIl19




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/eventually.js
 ** module id = 197
 ** module chunks = 0
 **/